module.exports = __webpack_public_path__ + "img/bow-rama.1ec77114.jpg";